import { useExperimentBucket } from '@carvana/experiment';
import { clientSideUserIdExperiments } from '~/constants/experiments';
import type { Experiments } from '~/contracts';
import useClientSide from '~/hooks/useClientSide';

export default function useCheckExperimentBucket(
  experiment: keyof Experiments,
  bucket: string
) {
  const assignedBucket = useExperimentBucket(experiment);
  const isClientSide = useClientSide();

  return clientSideUserIdExperiments[experiment] && !isClientSide
    ? false
    : assignedBucket === bucket;
}
